import type { ListTransactionsResponse_Tx } from "@openmoney/proto/openmoney/plaid/v1";

import { MoneyAmount } from "./MoneyAmount";

interface TransactionRowProps {
  transaction: ListTransactionsResponse_Tx;
}

export function TransactionRow({ transaction }: TransactionRowProps) {
  // Format date as "MMM DD, YYYY"
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <tr>
      <td className="text-sm">{formatDate(transaction.date)}</td>
      <td className="font-medium text-sm">{transaction.merchantName || "Unknown"}</td>
      <MoneyAmount value={transaction.amount} className="text-[--green] text-sm" asCells />
      <td className="text-xs">
        {transaction.pending ? (
          <span className="inline-block px-2 py-0.5 rounded-full bg-[--yellow-soft] text-[--yellow] font-medium">
            Pending
          </span>
        ) : (
          <span className="text-[--ink-muted]">Completed</span>
        )}
      </td>
    </tr>
  );
}
